import {
  AppBar,
  Box,
  Toolbar,
  useTheme,
  Typography,
  Fab,
  useMediaQuery,
} from "@mui/material";
import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Apps } from "@mui/icons-material";
import { Base } from "../base";
import { useSelector } from "../../store";
import Clock from "react-live-clock";
import MenuView from "./MenuView";
import ProfileMenuView from "./ProfileMenu";
import NavbarSearch from "./NavbarSearch";
import CompanyLogo from "../base/CompanyLogo";

interface Props {}

const NavbarView: React.FC<Props> = (props) => {
  const [desktopMenu, setDesktopMenu] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [userMenu, setUserMenu] = useState(false);
  const anchorRef = useRef<HTMLButtonElement | null>(null);
  const { loggedInUser, userCompany } = useSelector(
    (store) => store.authentication,
  );
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <AppBar
      position="fixed"
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, boxShadow: "none" }}
    >
      <Toolbar
        sx={{
          height: "65px",
          backgroundColor: theme.palette.background.paper,
          justifyContent: "space-between",
        }}
        disableGutters
      >
        <Box
          display={"flex"}
          flexDirection={"row"}
          gap={1}
          sx={{ pt: "1px" }}
          alignItems={"center"}
        >
          <Link to={"/"}>
            {userCompany?.logo ? (
              <Box py={"5px"} pl={1}>
                <CompanyLogo company={userCompany} size="55px" />
              </Box>
            ) : (
              <Base.Image
                src={"/static/images/SVPro.png"}
                alt="logo"
                style={{
                  height: { xs: "60px", sm: "100%" },
                  width: { xs: "100%", sm: 200 },
                }}
              />
            )}
          </Link>
          <Typography
            display={{ xs: "none", md: "flex" }}
            color="textPrimary"
            variant={"h3"}
            fontWeight="600"
          >
            <Clock
              ticking={true}
              format={"hh:mm:ss A"}
              style={{
                display: "flex",
              }}
            />
          </Typography>
        </Box>
        <Box
          display={"flex"}
          flexDirection={"row"}
          gap={1}
          alignItems={"center"}
          justifyContent={"flex-end"}
        >
          <Box>
            {!window.location.href.includes("reports") && <NavbarSearch />}
          </Box>
          <Box sx={{ mr: { md: 0, xs: 1 } }}>
            <Fab
              color={desktopMenu ? "info" : "primary"}
              aria-label="menu"
              size="medium"
              onClick={() => {
                if (!sm) {
                  setDesktopMenu(!desktopMenu);
                  if (userMenu) {
                    setUserMenu(false);
                  }
                } else {
                  setMobileMenu(!mobileMenu);
                }
              }}
            >
              <Apps />
            </Fab>
          </Box>
          <Box
            onClick={() => {
              setUserMenu(!userMenu);
              if (desktopMenu) {
                setDesktopMenu(false);
              }
            }}
            ref={anchorRef}
            sx={{
              display: { md: "flex", xs: "none" },
              justifyContent: "flex-end",
              mr: 1,
            }}
          >
            <Base.Avatar
              initials={`
            ${loggedInUser?.firstName?.charAt(
              0,
            )}${loggedInUser?.lastName?.charAt(0)}
            `}
              heightWidth={50}
            />
          </Box>
        </Box>
        <Base.Drawer
          open={desktopMenu}
          handleOpen={() => {
            if (userMenu) {
              setUserMenu(false);
            }
            setDesktopMenu(true);
          }}
          handleClose={() => setDesktopMenu(false)}
          contents={<MenuView handleClose={() => setDesktopMenu(false)} />}
        />
        <Base.Drawer
          open={userMenu}
          handleOpen={() => {
            if (desktopMenu) {
              setDesktopMenu(false);
            }
            setUserMenu(true);
          }}
          handleClose={() => setUserMenu(false)}
          contents={<ProfileMenuView handleClose={() => setUserMenu(false)} />}
        />
        <Base.Drawer
          open={mobileMenu}
          handleOpen={() => setMobileMenu(true)}
          handleClose={() => setMobileMenu(false)}
          contents={
            <>
              <ProfileMenuView
                handleClose={() => setMobileMenu(false)}
                children={<MenuView handleClose={() => setMobileMenu(false)} />}
              />
            </>
          }
        />
      </Toolbar>
    </AppBar>
  );
};

export default NavbarView;
